import { render, staticRenderFns } from "./Facilitador.vue?vue&type=template&id=313f3040&"
import script from "./Facilitador.vue?vue&type=script&lang=js&"
export * from "./Facilitador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports